import ProductivityChart from './ProductivityChart';

export default ProductivityChart;
